// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__20R_M","actions":"GroupTable_actions__2umI1","deleteModalFooter":"GroupTable_deleteModalFooter__1tFlJ"};